import { useMemo } from "react";
import { Sparkles } from "lucide-react";
import { buildAvatarSvg, svgDataUri } from "@/lib/avatar";
import type { Rarity, TraitSelection } from "@/types";

export function AvatarPreview({ traits, rarity = "Unrevealed", background = 0, speaking = false }: { traits: TraitSelection; rarity?: Rarity; background?: number; speaking?: boolean }) {
  const image = useMemo(() => svgDataUri(buildAvatarSvg(traits, background, rarity)), [traits, background, rarity]);
  return (
    <div className="relative overflow-hidden rounded-[28px] border border-white/10 bg-black shadow-[0_30px_100px_rgba(0,0,0,.45)]">
      <img alt="Current AniSoul avatar preview" className="aspect-square w-full" src={image} />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-200/80 to-transparent" />
      <div className="absolute bottom-4 left-4 flex items-center gap-2 rounded-full border border-white/10 bg-black/50 px-3 py-1.5 text-[11px] font-bold tracking-wider text-white/70 backdrop-blur">
        <span className={`size-2 rounded-full ${speaking ? "animate-pulse bg-pink-400" : "bg-emerald-400"}`} />
        {speaking ? "SPEAKING" : "SOUL ONLINE"}
      </div>
      <div className="absolute right-4 top-4 rounded-full border border-white/10 bg-black/45 px-3 py-1.5 text-xs text-cyan-100 backdrop-blur"><Sparkles className="mr-1 inline size-3" />{rarity}</div>
    </div>
  );
}
